import styled from 'styled-components';

const ArchiveItemDetails = styled.div`
  text-align: left;
  padding: 2rem;
`;

export default ArchiveItemDetails;
